import React from 'react';
export const InfoFill = () => /*#__PURE__*/React.createElement("svg", {
  width: "20",
  height: "20",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.49992 1.33331C4.81802 1.33331 1.83325 4.31808 1.83325 7.99998C1.83325 11.6819 4.81802 14.6666 8.49992 14.6666C12.1818 14.6666 15.1666 11.6819 15.1666 7.99998C15.1666 4.31808 12.1818 1.33331 8.49992 1.33331V1.33331ZM9.16658 10.6666C9.16658 11.0348 8.86811 11.3333 8.49992 11.3333C8.13173 11.3333 7.83325 11.0348 7.83325 10.6666V7.33331C7.83325 6.96512 8.13173 6.66665 8.49992 6.66665C8.86811 6.66665 9.16658 6.96512 9.16658 7.33331V10.6666ZM8.49992 5.99998C8.13173 5.99998 7.83325 5.7015 7.83325 5.33331C7.83325 4.96512 8.13173 4.66665 8.49992 4.66665C8.86811 4.66665 9.16658 4.96512 9.16658 5.33331C9.16658 5.7015 8.86811 5.99998 8.49992 5.99998Z",
  fill: "currentColor"
}));